import * as React from "react";

export const PleaseSelectElementNotification = (props: {message: string}) => {
    return <div className="no-element-selected-notification-container">
        <div className="no-element-selected-notification" data-testid="no-element-selected-notification">
            <b>{props.message}</b>
        </div>
    </div>;
};
